var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"in-report-manage"},[_c(_vm.views,{tag:"component",on:{"goEdit":_vm.goEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }